module.exports = __webpack_public_path__ + "static/media/sgcm-logo.22138719.svg";